"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue Mar 17 2020
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var ForecastSimulationSaveResultDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastSimulationSaveResultDTOConverter, _DataObjectConverter_);

  function ForecastSimulationSaveResultDTOConverter() {
    _classCallCheck(this, ForecastSimulationSaveResultDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationSaveResultDTOConverter).apply(this, arguments));
  }

  return ForecastSimulationSaveResultDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastSimulationSaveResultDTOConverter = ForecastSimulationSaveResultDTOConverter;